
export default function PickerOptions(request) {
  let first_time = true

   const  pickerOptions = {
        dateFormat: 'Y-m-d H:i:S',
        defaultDate: [
          new Date().setHours(0,0,0),
          new Date().setHours(23, 59, 59, 59),
        ],

        enableTime: true,
        enableSeconds: true,
        defaultHour: 0,
        mode: 'range',
        time_24hr: true,

        onClose: function(selectedDates, dateStr, instance) {
          const date = dateStr.split(' to ')
          request.from = date[0]
          request.to = date[1]
        },
        onChange(dates, dateStr, instance) {

          if (dates.length < 2) {
            first_time = true
          }

          else {
            if (first_time) {
              this.selectedDates[1].setHours(23, 59, 59, 59);
              first_time = false
            }
          }

          this.setDate(this.selectedDates)
        }
      }

      return { pickerOptions }
}



